var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { uploadFile, validateFile } from "../file-upload-utils/fileUploadUtil";
import { UploadButton } from "../file-upload-utils/styled-components/StyledFileUpload";
export const FileUploadButton = ({ authToken, contentTypes, label = "Choose file", maxFileSizeInMegaBytes, objectId, objectType, onFileValidated, onFilesChanged, onUploadFinished, showContentTypes = false, showMaxFileSize = false, stage, testId, }) => {
    const handleUpload = ({ target: { files }, }) => __awaiter(void 0, void 0, void 0, function* () {
        if (files !== null && files[0] !== undefined) {
            onFilesChanged(files);
            yield Promise.all([...files].map((file) => __awaiter(void 0, void 0, void 0, function* () {
                const validateFileResult = validateFile({
                    file,
                    contentTypes,
                    maxFileSizeInMegaBytes,
                });
                onFileValidated(validateFileResult);
                if (validateFileResult.isValid) {
                    const uploadFileResult = yield uploadFile({
                        stage,
                        authToken,
                        file,
                        objectId,
                        objectType,
                    });
                    onUploadFinished(uploadFileResult);
                }
            })));
        }
    });
    return (_jsx(UploadButton, { contentTypes: contentTypes, fullWidth: false, label: label, maxFileSizeInMegaBytes: maxFileSizeInMegaBytes, onChange: handleUpload, showContentTypes: showContentTypes, showMaxFileSize: showMaxFileSize, testId: testId }));
};
